import { render, staticRenderFns } from "./ChangeLicense.vue?vue&type=template&id=3b57494f&scoped=true&"
import script from "./ChangeLicense.vue?vue&type=script&lang=ts&"
export * from "./ChangeLicense.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57494f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b57494f')) {
      api.createRecord('3b57494f', component.options)
    } else {
      api.reload('3b57494f', component.options)
    }
    module.hot.accept("./ChangeLicense.vue?vue&type=template&id=3b57494f&scoped=true&", function () {
      api.rerender('3b57494f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/rooms/ChangeLicense.vue"
export default component.exports